"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { makeDataField } from './index.mjs';
import { DataBuilderForm } from './Form.mjs';

const EMPTY_FROZEN_FIELDS_LOCATORS = [];
function FieldList({
  schema,
  value,
  variablesSchema,
  isAdminMode,
  frozenFieldsLocators = EMPTY_FROZEN_FIELDS_LOCATORS,
  onChange,
  collapsed,
  hideReadOnlyFields,
  readOnly
}) {
  if (schema?.type !== "object") {
    return /* @__PURE__ */ jsx("span", { children: "Something went wrong. Trying to display a field list for schema that is not an object." });
  }
  const field = makeDataField({
    schema,
    value,
    variablesSchema
  });
  return /* @__PURE__ */ jsx(
    DataBuilderForm,
    {
      field,
      onChange,
      isAdminMode,
      readOnly,
      frozenFieldsLocators,
      collapsed,
      hideReadOnlyFields
    }
  );
}

export { FieldList };
